// extracted by mini-css-extract-plugin
export default {"simulateNow":"styles_simulateNow__aPNSr"};